// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function request(method: 'GET' | 'POST' | 'PUT' | 'DELETE', submitAddress: URL, data: { [key: string]: any }) {
    const options: RequestInit = {};
    const url = submitAddress;
    options.method = method;

    if (!(data instanceof FormData) && (method === 'GET' || method === 'DELETE')) {
        Object.entries(data).forEach(([key, value]) => {
            url.searchParams.append(key, value);
        });
    }

    if (method === 'POST' || method === 'PUT') {
        if (data instanceof FormData) {
            options.body = data;
        } else {
            options.body = JSON.stringify(data);
            options.headers = { 'Content-Type': 'application/json' };
        }
    }

    return await fetch(url, options);
}

export const useFormClient = () => request;
